module.exports = "<dw-badge dwStatus=\"default\" [dwText]=\"label\" [dwStyle]=\"{'background-color':color}\"></dw-badge>\n"